import { useMachine } from '@xstate/react'
import { useEffect } from 'react'

import { UserInformationBasic } from '@/api'

import { useClientsLayout } from '../clients-layout-provider'
import { editDfmUserMachine } from './state/edit-dfm-user.state'
import { editUserMachine } from './state/edit-user.state'

interface UseEditMachineProps {
  initialUser?: UserInformationBasic
  notifyParentOfSave: () => void
  user?: UserInformationBasic
}

export const useEditMachine = ({ notifyParentOfSave, user }: UseEditMachineProps) => {
  const { isPortfolioManagerScreen } = useClientsLayout()

  const [userMachine, sendUser] = useMachine(editUserMachine)
  const [dfmUserMachine, sendDfmUser] = useMachine(editDfmUserMachine)

  const send = isPortfolioManagerScreen ? sendDfmUser : sendUser
  const machine = isPortfolioManagerScreen ? dfmUserMachine : userMachine

  useEffect(() => {
    if (user) {
      send({ type: 'INIT', user, notifyParentOfSave })
    } else {
      send({ type: 'INIT_ADD', notifyParentOfSave })
    }
  }, [user, send, notifyParentOfSave])

  return { send, machine }
}
